// src/context/WalletContext.tsx

import React, { createContext, useState, useEffect } from 'react';
import { createAppKit } from '@reown/appkit';
import { SolanaAdapter } from '@reown/appkit-adapter-solana';
import { EthersAdapter } from '@reown/appkit-adapter-ethers';
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets';
import { solana, solanaDevnet, optimism, base, baseSepolia, optimismSepolia } from '@reown/appkit/networks';


interface WalletContextType {
  isConnected: boolean;
  publicKey: string | null;
  connectWallet: () => void;
}

export const WalletContext = createContext<WalletContextType | undefined>(undefined);

// Configure the AppKit modal
const ethersAdapter = new EthersAdapter();
const solanaAdapter = new SolanaAdapter({
  wallets: [new PhantomWalletAdapter(), new SolflareWalletAdapter()],
});

const projectId = import.meta.env.VITE_REOWN_PROJECT_ID;
const metadata = {
    name: 'Yuba',
    description: 'Yuba Wallet',
    url: 'https://example.com', // origin must match your domain & subdomain
    icons: ['https://avatars.githubusercontent.com/u/179229932']
  }

  const appKitModal = createAppKit({
    adapters: [ethersAdapter, solanaAdapter],
    networks: [solana, solanaDevnet, base, baseSepolia, optimism, optimismSepolia],
    metadata,
    projectId,
    features: {
      analytics: true,
      onramp: false,
      swaps: false,
    },
    allowUnsupportedChain: false
  })

export const WalletProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isConnected, setIsConnected] = useState(false);
  const [publicKey, setPublicKey] = useState<string | null>(null);

  useEffect(() => {
    const handleModalClose = (event: any) => {
      event;
      if (appKitModal.getIsConnectedState()) {
        setIsConnected(true);
        const walletInfo = appKitModal.getAddress();
        // console.log("WALLET APP KIT MODAL")
        // console.log(appKitModal.getWalletInfo())
        // console.log(appKitModal.getAddress())
        setPublicKey(walletInfo || null);
      } else {
        setIsConnected(false);
        setPublicKey(null);
      }
    };

    const unsubscribe = appKitModal.subscribeEvents(handleModalClose);

    return () => {
      unsubscribe()
    };
  }, []);

  const connectWallet = () => appKitModal.open();

  return (
    <WalletContext.Provider value={{ isConnected, publicKey, connectWallet }}>
      {children}
    </WalletContext.Provider>
  );
};
